import React, { useRef } from 'react';
import sales from "../assets/sales.svg";
import { fileUrl } from '../Tools/APIs/useMyAPI';

const Offers = (data) => {
  const sliderRef = useRef(null);
  let isDown = false;
  let startX;
  let scrollLeft;

  const handleMouseDown = (e) => {
    isDown = true;
    sliderRef.current.classList.add("cursor-grabbing");
    startX = e.pageX - sliderRef.current.offsetLeft;
    scrollLeft = sliderRef.current.scrollLeft;
  };

  const handleMouseLeave = () => {
    isDown = false;
    sliderRef.current.classList.remove("cursor-grabbing");
  };

  const handleMouseUp = () => {
    isDown = false;
    sliderRef.current.classList.remove("cursor-grabbing");
  };

  const handleMouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - sliderRef.current.offsetLeft;
    const walk = (x - startX) * 2; // سرعة السحب
    sliderRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <div id='offers' dir="rtl" className="flex flex-col w-[90%] mx-auto space-y-4">
      <h1 className="text-3xl font-bold text-blue-800 text-start">عروضنا</h1>

      <div
        ref={sliderRef}
        className="flex overflow-x-auto hide-scrollbar gap-4 px-2 cursor-grab"
        onMouseDown={handleMouseDown}
        onMouseLeave={handleMouseLeave}
        onMouseUp={handleMouseUp}
        onMouseMove={handleMouseMove}
      >
        {data?.data?.data?.data?.offers?.data?.map((offer) => (
          <div
            key={offer.id}
            className="flex flex-col md:flex-row items-center min-w-[200px] md:min-w-[1100px] bg-white shadow-xl rounded-xl m-1 p-4"
          >
            {/* صورة يمين */}
            <img src={sales} alt="sales" className="w-20 h-20 md:w-auto md:h-auto mb-2 md:mb-0 md:ml-4" />

            {/* نص وسط */}
            <div className="flex flex-col text-center gap-1 md:gap-2 md:w-96 flex-1">
              <p className="text-xl md:text-3xl font-bold">{offer.name}</p>
              <p className="text-sm md:text-lg font-semibold break-all">
                {offer.link}
              </p>
            </div>

            {/* صورة يسار */}
            <div className="bg-[#81B9DE] rounded-2xl mt-4 md:mt-0 md:ml-auto md:h-full md:w-1/3 flex justify-center items-center">
              <img src={fileUrl + offer.image} alt="offer" className="w-32 h-32 md:w-80 md:h-80 object-contain p-2" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Offers;
